// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__3lgh_","header":"styles_header__i1icx","back":"styles_back__1pHY-","title":"styles_title__uzdX_","content":"styles_content__2YlhI"};